module.exports = __webpack_public_path__ + "assets/img/personal-back.96332d8b.png";